import { useSidePopout } from 'modules/layout';
import { Button, ButtonType } from 'modules/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ContactPathsEnum } from '../../../../contactPage/routes';
import { FooterButtonsWrapper } from '../../login/components/styled';

export const FooterButtons: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { closePopout } = useSidePopout();

  const redirectToContactForm = () => {
    closePopout();
    history.push({
      pathname: ContactPathsEnum.contactPage,
    });
  };

  return (
    <FooterButtonsWrapper>
      <Button
        type={ButtonType.Text}
        text={t('landingPage.loginForm.customerSupport')}
        onClick={redirectToContactForm}
      />
    </FooterButtonsWrapper>
  );
};
